import { downloadClientListReport } from '../js/clientListReport';
import { getWhiteLabelBrand } from '../js/whiteLabel';

export default {
  async prepare() {},
  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },
  async loadPage() {
    this.applyWhiteLabel();
  },

  applyWhiteLabel() {
    const brand = getWhiteLabelBrand();
    if (!brand) return;

    const root = U.id('shadowDiv') || document;
    const eyebrow = root.querySelector('.hero-panel--home .hero-eyebrow');
    if (!eyebrow) return;

    eyebrow.querySelector('.hero-eyebrow__icon')?.remove();
    eyebrow.querySelector('.hero-eyebrow__text')?.remove();
    eyebrow.classList.add('hero-eyebrow--branded');

    const logo = document.createElement('img');
    logo.className = 'hero-eyebrow__brand';
    logo.src = brand.logo;
    logo.alt = brand.alt;
    eyebrow.append(logo);
  },

  async openClientReports() {
    await downloadClientListReport();
  },
};
